import {
  LOGIN_USER_OTT,
  LOGIN_USER_OTT_SUCESS,
  LOGIN_USER_OTT__FAIL,

  LOGOUT_USER,

  CHECK_EMAIL_FETCH,
  CHECK_EMAIL_FETCH_SUCCESS,
  CHECK_EMAIL_FETCH_FAIL,

  CHECK_TEL_FETCH,
  CHECK_TEL_FETCH_SUCCESS,
  CHECK_TEL_FETCH_FAIL
} from '../actions';

export const loginUser = (user, history, desiredPath) => ({
  type: LOGIN_USER_OTT,
  payload: { user, history, desiredPath }
});
export const loginUserSuccess = (user) => ({
  type: LOGIN_USER_OTT_SUCESS,
  payload: user
});
export const loginUserError = (message) => ({
  type: LOGIN_USER_OTT__FAIL,
  payload: { message }
});

export const logoutUser = (history) => ({
  type: LOGOUT_USER,
  payload: { history }
});

/* check mail */
export const checkMailFetch = (checkMail) => ({
  type: CHECK_EMAIL_FETCH,
  payload: { checkMail }
});

export const checkMailFetchSuccess = (checkMail) => ({
  type: CHECK_EMAIL_FETCH_SUCCESS,
  payload: { checkMail }
});

export const checkMailFetchFail = (message, statusCode) => ({
  type: CHECK_EMAIL_FETCH_FAIL,
  payload: { message, statusCode }
});

/* check tel */
export const checkTelFetch = (checkTel) => ({
  type: CHECK_TEL_FETCH,
  payload: { checkTel }
});

export const checkTelFetchSuccess = (checkTel) => ({
  type: CHECK_TEL_FETCH_SUCCESS,
  payload: { checkTel }
});

export const checkTelFetchFail = (message, statusCode) => ({
  type: CHECK_TEL_FETCH_FAIL,
  payload: { message, statusCode }
});